import Image from 'next/image';
import { useRouter } from 'next/router';
import logoWheelleft from '@/public/images/logo_wheel_left.svg';
import logoWheelright from '@/public/images/logo_wheel_right.svg';
import settings from '@/settings/configs';
import { getShortenCountryName } from '@/lib/use-origin-country';
import { WebsiteSchema } from '@/components/homepage/WebsiteSchema';
import CognitoLoginForm from '@/components/commons/Customer/CognitoLoginForm';
import i18n from '@/settings/i18n';

const t = i18n.init('auth');

export default () => {
  const router = useRouter();

  return (
    <>
      <WebsiteSchema
        title={t`Account Login - Reebelo ${{
          country: getShortenCountryName(),
        }}`}
        description={t`Reebelo ${{
          country: settings.country,
        }} is APAC's leading marketplace for sustainable tech with offices in ${{
          offices: settings.country_office_locations,
        }}. The positive customer experience at Reebelo ${{
          country: settings.country,
        }} is of utmost importance to us. Please check here for Reebelo ${{
          country: settings.country,
        }} Account Login.`}
      />
      <div className="relative bg-teal-500 py-5 md:py-14">
        <div className="reebelo-container my-0 md:my-2">
          <div className="mx-auto w-full max-w-[520px] rounded-[5px] bg-white px-6 py-5 shadow-xl md:px-20 md:py-10">
            <CognitoLoginForm
              onSuccess={() => {
                // TODO extract it into a common function/hook
                const redirectFromQuery =
                  typeof router.query.redirectUrl === 'string'
                    ? router.query.redirectUrl
                    : null;
                const redirectFromSession =
                  sessionStorage.getItem('postLoginRedirect');
                const redirect = redirectFromSession || redirectFromQuery;

                sessionStorage.removeItem('postLoginRedirect');
                router.push(redirect || '/account/orders');
              }}
            />
          </div>
        </div>
        <div className="absolute left-0 top-0 hidden lg:block">
          <Image
            height={104}
            width={208}
            alt="logoWheelleft"
            src={logoWheelleft}
          />
        </div>
        <div className="absolute bottom-0 right-0 hidden leading-[0] lg:block">
          <Image
            height={392}
            width={241}
            alt="logoWheelright"
            src={logoWheelright}
          />
        </div>
      </div>
    </>
  );
};
